module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Hy38Za/tc-custom/9781955835077.jpg?1721404537774",
      "alt": "This image is the cover for the book Free People, Free Markets"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Free People, Free Markets\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The author of Eternal Vigilance presents “")]), _c('b', [_vm._v("a compelling, new perspective on economic, political and cultural history” (Phillip Scribner, Associate Professor of Philosophy Emeritus, American University).")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Adam Smith, the 18th century father of modern economics, once posed a provocative question: Why do some nations prosper while others do not? In "), _c('i', [_vm._v("Free People, Free Markets")]), _vm._v(", author Ralph L. Bayrer presents the answer."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Combining the economic theories of Smith, Friedrich von Hayek, and contemporary scholarship, Bayrer demonstrates the vital role of freedom in the creation of prosperity. In America as well as across the Western world, liberty, free markets, and scientific progress have been the all-important pillars of modern progress."), _c('br'), _vm._v(" "), _c('br'), _c('b', [_vm._v("“Relying on thorough scholarship and clarity of argument, Bayrer makes the compelling case that mankind’s progress in the last millennium rests on a narrow foundation of freedom, a lesson people forget at their peril.” —John McCain, US Senator")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ralph L. Bayrer\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    New Academia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0